import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const smugmug = defineConnector({
  identifier: "smugmug",
  name: "SmugMug",
  tagLine: "Photo hosting and portfolio",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://www\\.smugmug\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Find your SmugMug API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Go to [SmugMug API Keys](https://api.smugmug.com/api/developer/apply) and request an API key for your application.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Enter the API credentials from your SmugMug account settings.",
        },
        {
          kind: "input",
          label: "SmugMug API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://www.smugmug.com/api/v2!authuser",
  },
});
